module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/military-school-lvl1-100.039d871f.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/military-school-lvl1-100.png
// module id = 3543
// module chunks = 11